/**
 * @flow
 * @relayHash df92ed54b81c7811b4ec27b0ede32d5b
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteCurrencyMutationVariables = {|
  id: string
|};
export type DeleteCurrencyMutationResponse = {|
  +deleteCurrency: {|
    +id: string
  |}
|};
export type DeleteCurrencyMutation = {|
  variables: DeleteCurrencyMutationVariables,
  response: DeleteCurrencyMutationResponse,
|};
*/


/*
mutation DeleteCurrencyMutation(
  $id: String!
) {
  deleteCurrency(id: $id) {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteCurrency",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "CurrencyModel",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeleteCurrencyMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "DeleteCurrencyMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "DeleteCurrencyMutation",
    "id": null,
    "text": "mutation DeleteCurrencyMutation(\n  $id: String!\n) {\n  deleteCurrency(id: $id) {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'c2f88346188b50bb622f39bdba361da7';
module.exports = node;
